<template lang="pug">
.globalLoading(:class='{shown: shown}', @click.stop="doNothing")
  .center
    p {{text}}
    i.fa.fa-spin.fa-refresh

</template>
<script>
import eventsBus from '@/components/shared/EventsBus'
import Vue from 'vue'

export default {
  data() {
    return {
      shown: false,
      text: Vue.i18n.t('globals.loading')
    }
  },
  mounted() {
    eventsBus.$on(eventsBus.SHOW_LOADING, data => {
      if (data) {
        this.text = data
      } else {
        this.text = Vue.i18n.t('globals.loading')
      }
      this.shown = true
    })
    eventsBus.$on(eventsBus.HIDE_LOADING, data => {
      this.shown = false
    })
  },
  methods: {
    doNothing () {}
  }
}
</script>
<style lang="sass">
.globalLoading
  background-color: #3498DB
  z-index: 99999999
  position: fixed
  left: 0
  right: 0
  transition: opacity 1s ease 0.5s
  bottom: 0vh
  top: 0vh
  opacity: 0
  pointer-events: none
  .center
    position: absolute
    text-align: center
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    color: white
  &.shown
    pointer-events: auto
    opacity: 0.6
      
</style>



// WEBPACK FOOTER //
// GlobalLoading.vue?6e75ce1c